<template>
    <div class="offer-list" id="offer-list">
        <div v-if="getData || getData && getData.length > 0">
            <div class="title" v-if="getData.length">识图产品列表（已识别{{getData.length}}件）</div>
            <div class="item" v-for="(item,index) in getData" @click="replaceHandle(item, index)" :key="index">
                <div class="left">
                     <span v-if="progress > 0 && replaceIndex === index" class="file-list-loading">
                        <img src="../../../../src/images/Rolling.gif" alt="">
                    </span>
                    <div v-else class="leftCon">
                        <img :src="imgBaseUrl + item.imgKey + '?x-oss-process=image/crop,x_' + parseInt(item.ossPoint.x) + ',y_' + parseInt(item.ossPoint.y) + ',w_' + parseInt(item.ossPoint.w) + ',h_' + parseInt(item.ossPoint.h)"
                             alt="">
                        <div class="replace">
                        <span>
                            <i class="iconfont icon-exchange"></i>
                            <p>替换图片</p>
                        </span>
                        </div>
                    </div>
                    <my-upload v-show="progress === 0" :format="['jpg','jpeg','png']"
                               :maxSize="5120"
                               :multiple="false"
                               :type="1"
                               @success="handleSuccess"
                               @uploadError="handleUploadError"
                               @formatError="handleFormatError"
                               @maxSizeError="handleMaxSizeError"
                               @progress="handleProgress"
                    >
                    </my-upload>
                </div>
                <div class="right">
                    <div class="mate">
                        <span><span style="color:red;color:red; width: initial;">*</span>产品名：</span>
                        <input type="text" v-model="item.name" maxlength="20">
                    </div>
                    <div class="mate">
                        <span><span style="color:red; width: initial;">*</span>材   质：</span>
                        <input type="text" v-model="item.material" maxlength="30">
                    </div>
                    <div class="mate">
                        <span>定制要求：</span>
                        <input type="text" v-model="item.remark" maxlength="200" placeholder="请填写备注信息（200字以内）">
                    </div>
                    
                    <div class="mate" @click="deleteProduct(index)">
                        <i class="iconfont icon-trash"></i>
                        删除产品
                    </div>
                </div>
            </div>

            <div class="choiced" v-if="getData && getData.length > 0">
                <!-- <span>
                    <span class="de">*</span>
                    选择报价结果存储的清单
                </span>
                <choice-list
                        style="display: inline-block" :target="true"
                        @getChoicedListHandle="getChoicedListHandle">
                </choice-list> -->
                 <Enquiry :lists="getData"></Enquiry>
            </div>
        </div>

    </div>
</template>

<script>
    import api from '../../../api';
    import myUpload from '../../common/myUpload.vue';
    import choiceList from '../../common/choiceList.vue'
import Enquiry from './enquiry.vue'
    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                listData: null,
//                choicedList: '',
                replaceIndex: null,
                progress: 0
            };
        },
        computed: {
            getData(){
                return this.$store.state.app.identtificationData
            },
            user() {
                return this.$store.state.user.info;
            },
        },
        components: {myUpload, choiceList, Enquiry},
        methods: {
            handleSuccess(value){
                //识别图片
                api.imgSearch.detect_url(this.imgBaseUrl + value.data[0].key)
                    .then(res => {
                        let name;
                        if (!res.detectedBoxes || res.detectedBoxes.length === 0) {
                            name = '其他'
                        } else {
                            name = res.detectedBoxes[0].type
                        }
                        let object = {
                            'key': value.data[0].key,
                            'index': this.replaceIndex,
                            'name': name,
                            'remark': '',
                        }
                        this.progress = 0;
                        this.$store.dispatch('replaceIdenttification', object);
                    })
            },
            handleUploadError(){
                this.$Message.error('上传失败,请重新上传');
            },
            handleFormatError(){
                this.$Message.error('请选择 jpg,jpeg 或 png 格式的文件');
            },
            handleMaxSizeError(){
                this.$Message.error('请选择小于 5M 的图片');
            },
            handleProgress(progress){
                this.progress = progress;
            },
            deleteProduct(index){
                this.$store.dispatch('deleteIdenttification', index);
            },
            replaceHandle(item, index){
                this.replaceIndex = index;
            },
            getChoicedListHandle(id){
                this.$emit('getList', id)
            },
            timeChange(value){
                if (!value) {
                    return '';
                }
                let d = new Date(value);
                let year = d.getFullYear();
                let month = '0' + (d.getMonth() + 1);
                let day = '0' + d.getDate();
                let hour = '0' + d.getHours() + '';
                let minutes = '0' + d.getMinutes() + '';
                let seconds = '0' + d.getSeconds() + '';
                return year + '-' + month.substr(-2, 2) + '-' + day.substr(-2, 2) + ' ' + hour.substr(-2, 2) + ':'
                    + minutes.substr(-2, 2) + ':' + seconds.substr(-2, 2);
            },
//            getValue(id){
//                this.$emit('getList', id)
//            }
        },
        watch: {
//            'user': function () {
//                this.listAjax();
//            }
        },
        created() {
//            if (this.user) {
//                this.listAjax();
//            }
        }
    };
</script>
<style>
    #offer-list .upload {
        position: absolute !important;
        left: 0px;
        top: 0px;
        cursor: pointer;
    }
</style>
<style rel="stylesheet/scss" lang="scss" scoped type="text/scss">
    .offer-list {
        width: 100%;
        margin-top: 52px;
        margin-bottom: 58px;
        .title {
            font-size: 20px;
            color: #353838;
        }
        .item {
            margin-top: 20px;
            height: 160px;
            display: inline-block;
            width: 535px;
            vertical-align: top;
            .left {
                display: inline-block;
                height: 160px;
                width: 160px;
                font-size: 0px;
                border: 1px solid #ddd;
                text-align: center;
                line-height: 160px;
                vertical-align: middle;
                position: relative;
                &:hover .replace {
                    display: block;
                }
                img {
                    max-width: 100%;
                    max-height: 99%;
                    vertical-align: middle;
                    cursor: pointer;
                    margin-top: -3px;
                }
                .replace {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    background: rgba(53, 56, 56, 0.5);
                    text-align: center;
                    display: none;
                    cursor: pointer;
                    span {
                        display: inline-block;
                        width: 77px;
                        height: 77px;
                        text-align: center;
                        background: #FFFFFF;
                        border-radius: 50%;
                        margin-top: 41px;
                        line-height: 20px;
                        i {
                            display: inline-block;
                            font-size: 20px;
                            color: rgba(0, 0, 0, 0.65);
                            margin-top: 15px;
                        }
                        p {
                            font-size: 14px;
                            color: #353838;
                        }
                    }
                }
                .file-list-loading {
                    display: inline-block;
                }
                .leftCon {
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                }
            }
            .right {
                display: inline-block;
                vertical-align: top;
                margin-left: 20px;
                width: 350px;
                .mate {
                    display: inline-block;
                    margin-bottom: 20px;
                    span {
                        display: inline-block;
                        width: 70px;
                        vertical-align: middle;
                        font-size: 14px;
                        color: #353838;
                    }
                    input {
                        display: inline-block;
                        width: 260px;
                        height: 30px;
                        padding: 0 17px;
                        border: none;
                        background: #EBEFF0;
                        font-size: 14px;
                        color: #353838;
                        vertical-align: middle;
                    }
                    &:last-child {
                        width: 30%;
                        float: right;
                        text-align: right;
                        font-size: 14px;
                        color: #6C6F70;
                        vertical-align: middle;
                        margin-top: -10px;
                        margin-right: 20px;
                        cursor: pointer;
                        i {
                            font-size: 16px;
                            color: #6C6F70;
                            margin-right: 6px;
                            vertical-align: top;
                        }
                        &:hover {
                            color: #353838;
                            i {
                                color: #353838;
                            }
                        }
                    }
                }
            }
            &:nth-child(odd) {
                margin-left: 60px;
            }
        }
        .choiced {
            margin-top: 45px;
            > span {
                font-size: 20px;
                color: #171A1A;
                margin-right: 12px;
                vertical-align: middle;
                .de {
                    font-size: 14px;
                    color: #E14B5D;
                    vertical-align: middle;
                }
            }
        }
    }
</style>

